// extracted by mini-css-extract-plugin
export var cardLayout = "_83-1";
export var paginationContainer = "_83-0";